import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlarmsService } from '@API/alarms/alarms.service';
import { LogicalGrowthComponentsModule } from '@app/logical-growth-components/logical-growth-components.module';
import { Alarm } from '@interfaces/alarm';
import { formatAlarmForReadUpdate } from '@utils/alarm/alarm-datetime.utils';
import { communicationMediumDicc, ComponentStatus } from '@utils/constants';
import {
  NotificationService,
  NotificationSeverity,
} from '@utils/services/notification.service';

@Component({
  selector: 'app-alarm-modal',
  standalone: true,
  imports: [CommonModule, LogicalGrowthComponentsModule],
  templateUrl: './alarm-modal.component.html',
  styleUrls: ['./alarm-modal.component.scss'],
})
export class AlarmModalComponent {
  private readonly _dialogRef = inject(DialogRef<boolean>);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _alarmService = inject(AlarmsService);
  private readonly _notificationService = inject(NotificationService);
  private readonly _dialogData = inject<Alarm>(DIALOG_DATA);

  public readonly data: Alarm;
  public status: ComponentStatus = 'init';
  public readonly mediumDicc = communicationMediumDicc;

  constructor() {
    this.data = this._dialogData;
  }

  public markAsRead(): void {
    const body = formatAlarmForReadUpdate(this.data);

    this._alarmService
      .updatePartial(this.data.id, body)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: () => {
          this._notificationService.create({
            severity: NotificationSeverity.success,
            summary: 'Actualización de alerta',
            detail: 'La alerta ha sido actualizada correctamente',
            sticky: false,
          });
          this.status = 'success';
          this._dialogRef.close(true);
        },
        error: () => {
          this.status = 'error';
        },
      });
  }
}
